import { AppBar, ThemeProvider, Toolbar, styled, useTheme } from "@mui/material";
import { FC } from "react";
import { Paragraph, Span } from "./Typography";
import useSettings from "../../hooks/useSettings";
import { TOP_BAR_HEIGHT } from "../../utils/constants";

const DashboardFooter = styled(Toolbar)(() => ({
  display: "flex",
  alignItems: "center",
  minHeight: TOP_BAR_HEIGHT,
  "@media (max-width: 499px)": {
    display: "table",
    width: "100%",
    minHeight: "auto",
    padding: "1rem 0",
    "& .container": {
      flexDirection: "column !important",
      "& a": { margin: "0 0 16px !important" }
    }
  }
}));

const FooterContent = styled("div")(() => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  padding: "0px 1rem",
  maxWidth: "1170px",
  margin: "0 auto"
}));

const Footer: FC = () => {
  const theme = useTheme();
  const { settings } = useSettings();
  const footerTheme = settings.themes[settings.footer.theme] || theme;

  return (
    <ThemeProvider theme={footerTheme}>
      <AppBar color="primary" position="static" sx={{ zIndex: 96 }}>
        <DashboardFooter >
          <FooterContent>
            <Span m="auto"></Span>
            <Paragraph m={0}>
            </Paragraph>
          </FooterContent>
        </DashboardFooter >
      </AppBar>
    </ThemeProvider>
  );
};

export default Footer;